import React, { useEffect, useMemo, useRef } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { cartProductsSelector } from 'store/selectors/cart'
import { addEditProduct, openModal } from 'store/actions/cart'

import { useValidationSchema } from './validation'

import { Form } from './ProductForm.style'

const getDefaultGroups = (groups = []) => {
    const retGroups = {}
    if (groups && groups.length > 0) {
        groups.forEach((group) => {
            retGroups[group.type] = {
                cardQuantity: group.qnt,
                monthlyValue: group.value
            }
        })
    }
    return retGroups
}

const getDefaultValues = (values = {}) => ({
    cardQuantity: values?.qnt ?? '',
    monthlyValue: values?.value ?? '',
    groups: getDefaultGroups(values?.groups?.items),
    isPat: values?.isPat ?? false
})

const ProductForm = ({ children, cartProducts, product }) => {
    const schema = useValidationSchema()

    const cartProductInfo = cartProducts.find((cartProduct) => {
        return +product.code === +cartProduct.id
    })

    const lastCartProcuctInfo = useRef(cartProductInfo)

    const formMethods = useForm({
        defaultValues: getDefaultValues(cartProductInfo),
        resolver: yupResolver(schema),
        context: {
            minPerCard: 1,
            maxPerCard: 9999,
            minPerValue: product.minValue,
            maxPerValue: product.maxValue,
            product
        }
    })

    const { watch, trigger, formState, reset, clearErrors } = formMethods

    const isPatChecked = watch('isPat')

    useEffect(() => {
        if (
            JSON.stringify(lastCartProcuctInfo.current) !==
            JSON.stringify(cartProductInfo)
        ) {
            reset(getDefaultValues(cartProductInfo))
            setTimeout(() => {
                clearErrors()
            }, 0)
        }
        lastCartProcuctInfo.current = cartProductInfo
    }, [cartProductInfo, reset, clearErrors])

    useEffect(() => {
        if (formState.isSubmitted) {
            trigger()
            trigger('sumCardQuantity')
        }
    }, [isPatChecked, trigger, formState.isSubmitted])

    const groups = useMemo(
        () => product.groups.filter((g) => g.isPat.includes(isPatChecked)),
        [isPatChecked, product.groups]
    )
    const onSwitchChange = (_, onChange) => {
        onChange()
    }

    return (
        <Form>
            <FormProvider {...formMethods}>
                {React.Children.map(children, (child) =>
                    React.cloneElement(child, {
                        product,
                        groups,
                        onSwitchChange,
                        cartProductInfo
                    })
                )}
            </FormProvider>
        </Form>
    )
}

const mapStateToProps = (state) => ({
    cartProducts: cartProductsSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    addEditProduct: (product) => dispatch(addEditProduct(product)),
    openCartMenu: () => dispatch(openModal())
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProductForm)
)
